import httpUtil from "@/utils/httpUtil";

export const selectCodePrintList = params => httpUtil.get("/storeCodePrint", params);

export const addCodePrint = params => httpUtil.post("/storeCodePrint", params);
export const delCodePrint = params => httpUtil.post("/storeCodePrint/del", params);


export const selectAllPrintList = params => httpUtil.get("/storeCodePrint/noPage", params);
export const exportList = params => httpUtil.get("/storeOrders/export", params);


